namespace TabAurous.Production {
    export interface QualityInspectionRow {
        TransId?: number;
        TransDate?: string;
        RefVoucherId?: number;
        RefTransId?: number;
        RefVoucherNo?: string;
        EmployeeId?: number;
        UserId?: number;
        Items?: QualityInspectionItemsRow[];
    }

    export namespace QualityInspectionRow {
        export const idProperty = 'TransId';
        export const nameProperty = 'RefVoucherNo';
        export const localTextPrefix = 'Production.QualityInspection';
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            TransId = "TransId",
            TransDate = "TransDate",
            RefVoucherId = "RefVoucherId",
            RefTransId = "RefTransId",
            RefVoucherNo = "RefVoucherNo",
            EmployeeId = "EmployeeId",
            UserId = "UserId",
            Items = "Items"
        }
    }
}
